var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis/index';
import { AjaxBasics } from '../../libraries';
let CommonController = class CommonController {
    constructor() {
        this.codeTable = [];
        this.resellerTypeList = [];
        this.subtypeTypeList = [];
        this.rolesList = [];
        // 审批状态及对应颜色
        this.statusTypeEnum = {
            '0': {
                text: '待审批',
                color: '#1890FF',
            },
            '1': {
                text: '已通过',
                color: '#00B840',
            },
            '-1': {
                text: '已驳回',
                color: '#E1140A',
            },
        };
    }
    // 审核状态
    get approveStatusType() {
        return { '0': '待审批', '1': '已通过', '-1': '已驳回' };
    }
    // 获取码表
    getFieldName(field, value) {
        return (lodash.find(lodash.filter(this.codeTable, ['dicType', field]), [
            'itemId',
            value,
        ])?.itemName || '');
    }
    // 渠道类型子类型
    getReseller(value) {
        if (lodash.isEmpty(value)) {
            return '';
        }
        let arr = lodash.map(value, this.resellerTypeJoint);
        return lodash.toString(arr).replace(/\,/g, '；');
    }
    resellerTypeJoint(item) {
        let subList = lodash.find(this.subtypeTypeList, ['resellerTypeId', item.typeId])
            ?.subtypeList || [];
        const resellerName = lodash.find(this.subtypeTypeList, ['resellerTypeId', item.typeId])
            ?.resellerTypeName || '';
        const resellerSubName = lodash.find(subList, ['resellerSubtypeId', item.subtypeId])
            ?.resellerSubtypeName || '';
        return `${resellerName} ${resellerSubName ? '- ' + resellerSubName : ''}`;
    }
    // 渠道类型
    getResellerTypeName(value) {
        return (lodash.find(this.subtypeTypeList, ['resellerTypeId', value])
            ?.resellerTypeName || '');
    }
    // 渠道子类型
    getSubResellerTypeName(typeId, subtypeId) {
        let subList = lodash.find(this.subtypeTypeList, ['resellerTypeId', typeId])
            ?.subTypeInfos || [];
        return (lodash.find(subList, ['resellerSubTypeId', subtypeId])
            ?.resellerSubtypeName || '');
    }
    // 角色
    getRoleName(value) {
        if (!value)
            return;
        const splitRole = value.split(',');
        let arr = lodash.map(splitRole, (item) => {
            return (lodash.find(this.rolesList, ['id', Number(item)])?.roleName || '--');
        });
        return lodash.toString(arr);
    }
    // 角色
    /**
     * 获取省份
     * @memberof CommonController
     */
    async getProvides() {
        return await AjaxBasics.request({ ...EnumAPI.usersvr_get_provinces });
    }
    /**
     * 获取城市
     * @memberof CommonController
     */
    async getCitys(provideCode) {
        return await AjaxBasics.request({
            ...EnumAPI.usersvr_get_citys,
            body: { provideCode },
        });
    }
    /**
     * 获取区县、街道
     * @memberof CommonController
     */
    async getDistrict(cityCode) {
        return await AjaxBasics.request({
            ...EnumAPI.usersvr_get_district,
            body: { cityCode },
        });
    }
    /**
     * 企业相关获取省份
     * @memberof CommonController
     */
    async enterpriseGetProvides() {
        return await AjaxBasics.request({ ...EnumAPI.regionorg_get_provinces });
    }
    /**
     * 企业相关获取城市
     * @memberof CommonController
     */
    async enterpriseGetCitys(provincecode) {
        return await AjaxBasics.request({
            ...EnumAPI.regionorg_get_citys,
            body: { provincecode },
        });
    }
    /**
     * 企业相关获取区县、街道
     * @memberof CommonController
     */
    async enterpriseGetDistrict({ provincecode, citycode }) {
        return await AjaxBasics.request({
            ...EnumAPI.regionorg_get_district,
            body: { provincecode, citycode },
        });
    }
};
CommonController = __decorate([
    BindAll()
], CommonController);
export { CommonController };
